enum DropDownValidations {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
}
enum DropDownType {
  DEFAULT = 'default',
  MULTI_SELECT = 'multi-select',
  INLINE = 'inline',
}

enum DropDownDirection {
  UPWARDS = 'upwards',
  DOWNWARDS = 'downwards',
}

enum DropDownFilterBy {
  STARTS_WITH = 'startsWith',
  INCLUDES = 'includes',
}

export { DropDownValidations, DropDownType, DropDownDirection, DropDownFilterBy };
